import classNames from '../../utils/classNames.js';

const defaultSections = [
    { name: 'Dashboard', shortName: 'Dashboard', group: 'Command', current: true, index: 0 },
    { name: 'Billing Details', shortName: 'Billing', group: 'Revenue', current: false, index: 1 },
    { name: 'Extractions', shortName: 'Extractions', group: 'Usage', current: false, index: 2 },
    { name: 'Classifications', shortName: 'Classify', group: 'Usage', current: false, index: 3 },
    { name: 'Authentication', shortName: 'Users', group: 'Users', current: false, index: 4 },
    { name: 'Credits', shortName: 'Credits', group: 'Revenue', current: false, index: 5 },
    { name: 'Subscriptions', shortName: 'Plans', group: 'Revenue', current: false, index: 6 },
    { name: 'Buy Button History', shortName: 'Buy History', group: 'Revenue', current: false, index: 7 },
    { name: 'Queue Status', shortName: 'Queues', group: 'Operations', current: false, index: 8 },
    { name: 'User Job Stats', shortName: 'Jobs', group: 'Operations', current: false, index: 9 },
    { name: 'Inbound emails', shortName: 'Inbound', group: 'Operations', current: false, index: 10 },
    { name: 'Safari runs', shortName: 'Safari', group: 'Operations', current: false, index: 11 },
    { name: 'Workflow extractions', shortName: 'Workflows', group: 'Usage', current: false, index: 12 },
];

export default function TabsDashboard({ sections = defaultSections, setViewNumber, viewNumber }) {
    const tabs = sections.map((section) => ({
        ...section,
        current: viewNumber === section.index,
    }));

    const groupedTabs = tabs.reduce((groups, tab) => {
        const group = tab.group || 'Admin';
        if (!groups[group]) groups[group] = [];
        groups[group].push(tab);
        return groups;
    }, {});

    const groupOrder = ['Command', 'Revenue', 'Usage', 'Users', 'Operations'];
    const sortedGroups = groupOrder
        .filter((group) => groupedTabs[group]?.length)
        .concat(Object.keys(groupedTabs).filter((group) => !groupOrder.includes(group)));

    const handleChange = (event) => {
        setViewNumber(Number(event.target.value));
    };

    return (
        <aside className="admin-nav" aria-label="Admin sections">
            <div className="admin-nav-mobile">
                <label htmlFor="admin-tabs" className="sr-only">
                    Select an admin section
                </label>
                <select
                    id="admin-tabs"
                    name="admin-tabs"
                    onChange={handleChange}
                    value={viewNumber}
                    className="admin-select"
                >
                    {tabs.map((tab) => (
                        <option key={tab.name} value={tab.index}>{tab.name}</option>
                    ))}
                </select>
            </div>

            <div className="admin-nav-desktop">
                <div className="admin-nav-title">
                    <span>Admin Map</span>
                    <strong>{tabs.length}</strong>
                </div>

                {sortedGroups.map((group) => (
                    <div className="admin-nav-group" key={group}>
                        <p>{group}</p>
                        <div className="admin-nav-items">
                            {groupedTabs[group].map((tab) => {
                                const Icon = tab.icon;

                                return (
                                    <button
                                        key={tab.name}
                                        type="button"
                                        onClick={() => setViewNumber(tab.index)}
                                        className={classNames(
                                            tab.current ? 'admin-nav-item active' : 'admin-nav-item',
                                        )}
                                        aria-current={tab.current ? 'page' : undefined}
                                    >
                                        <span className="admin-nav-icon">
                                            {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
                                        </span>
                                        <span className="admin-nav-copy">
                                            {tab.shortName || tab.name}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </aside>
    )
}
